import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule],
  template: `
    <!-- Notifications will be handled by Angular Material SnackBar -->
    <!-- This component serves as a placeholder for global notification management -->
  `,
  styles: [`
    :host {
      display: block;
    }

    // Global notification styles
    :host ::ng-deep .mat-mdc-snack-bar-container {
      .mat-mdc-snack-bar-surface {
        border-radius: 8px;
        box-shadow: var(--shadow-lg);
      }

      &.success-snackbar .mat-mdc-snack-bar-surface {
        background-color: var(--color-success);
        color: white;
      }

      &.error-snackbar .mat-mdc-snack-bar-surface {
        background-color: var(--color-error);
        color: white;
      }

      &.warning-snackbar .mat-mdc-snack-bar-surface {
        background-color: var(--color-warning);
        color: white;
      }

      &.info-snackbar .mat-mdc-snack-bar-surface {
        background-color: var(--color-primary-600);
        color: white;
      }
    }
  `]
})
export class NotificationComponent {
  // This component will be used with NotificationService
  // to handle global notifications throughout the app
}
